module.exports = __webpack_public_path__ + "img/cup_ctf.75d11836.svg";